import http from "../httpService";
import {getBaseUrl} from "../../config";

export const getDiscountUsageReport = (paginate) => {

  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/discount_usage_report`,
    );
  }
  return http.get(
    `${getBaseUrl()}/discount_usage_report?${paginate}`,
  );
};

export const getDiscountSiteCostReport = (paginate) => {

  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/discount_site_cost_report`,
    );
  }
  return http.get(
    `${getBaseUrl()}/discount_site_cost_report?${paginate}`,
  );
};